import { useTranslation } from 'react-i18next';
import ClientChangeOrdersPanel from '@/pages/client/change-orders/ClientChangeOrdersPanel';

interface Props {
  projectId: string | null;
}

export default function ClientChangeOrdersEmbed({ projectId }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="bg-[#FEF0E7] rounded-2xl p-4 mb-4">
        <div className="flex items-center gap-2 mb-1">
          <i className="ri-exchange-line text-[#E8621A] text-base"></i>
          <span className="text-[#374151] text-sm font-bold">{t('nav.changeOrders')}</span>
        </div>
        <p className="text-[#374151] text-sm">{t('client.changeOrders.tabDesc')}</p>
      </div>
      <ClientChangeOrdersPanel projectId={projectId} compact />
    </div>
  );
}
